'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetTitleText = undefined;

var _getAnyCustomChatName = require('conversations-schema/chat-heading-config/operators/getAnyCustomChatName');

var _getRespondersNameText = require('./getRespondersNameText');

var getWidgetTitleText = exports.getWidgetTitleText = function getWidgetTitleText(chatHeadingConfig, responders, locale) {
  var responderNames = (0, _getRespondersNameText.getRespondersNameText)(responders, locale);
  return responderNames || (0, _getAnyCustomChatName.getAnyCustomChatName)(chatHeadingConfig);
};